import React, {useEffect} from 'react';
import {getLoyaltyInformation} from '../../../store/actions/companies';

//Components
import Loader from 'react-loader-spinner'
import {Trans} from "react-i18next";

//Hooks
import {useDispatch, useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'


//Styles
import Styles from './LoyaltyPoints.module.scss';

const LoyaltyPoints = () => {
    const loyaltyInformation = useSelector(state => state.companies.loyaltyInformation);
    const profile = useSelector(state => state.profile.profile);
    const dispatch = useDispatch();

    const {t} = useTranslation('common');

    useEffect(() => {
        dispatch(getLoyaltyInformation());
    }, [dispatch]);

    if (!loyaltyInformation || !profile) {
        return (
            <div className={Styles.container}>
                <Loader type="TailSpin" color="#000" height={40} width={40}/>
            </div>
        )
    }

    const {loyaltyPoints} = profile;
    const {needPoints, loyaltyDescription} = loyaltyInformation;

    return (
        <>
            <div className={Styles.container}>
                <div>
                    <p className={Styles.pointTitle}>{loyaltyPoints}</p>
                    <p className={Styles.pointSubTitle}>{t('myProfile.loyaltyPoints.loyaltyPoints')}</p>
                </div>
                <div className={Styles.bar}>
                    <div
                        className={Styles.barProgress}
                        style={{
                            width: loyaltyPoints > needPoints ? '100%' : `${((loyaltyPoints) / needPoints) * 100}%`
                        }}
                    />
                </div>
                <p className={Styles.needPoints}>
                    <Trans
                        i18nKey={'common:myProfile.loyaltyPoints.needPoints'}
                        count={needPoints - loyaltyPoints} components={[
                        <span className={Styles.needPointsBold}/>
                    ]}
                        values={{points: (needPoints)}}
                    >
                        You need <span className={Styles.needPointsBold}> {needPoints} point</span>
                    </Trans>
                </p>
                <div className={Styles.description}>
                    <p>{loyaltyDescription}</p>
                </div>
            </div>
        </>
    )
};

export default LoyaltyPoints